/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopProductDto } from '../../models/shop-product-dto';
import { ShopProductUpdateStatusDto } from '../../models/shop-product-update-status-dto';

export interface ShopProductAdminControllerUpdateStatusV1$Params {

/**
 * 상품 ID
 */
  id: string;
      body: ShopProductUpdateStatusDto
}

export function shopProductAdminControllerUpdateStatusV1(http: HttpClient, rootUrl: string, params: ShopProductAdminControllerUpdateStatusV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopProductDto>> {
  const rb = new RequestBuilder(rootUrl, shopProductAdminControllerUpdateStatusV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopProductDto>;
    })
  );
}

shopProductAdminControllerUpdateStatusV1.PATH = '/api/v1/shop-products/admin/{id}/status';
